import { assert_array_not_empty, assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTOTokenCreateData } from '@shared/dto/generation/settings/token/dto_token_create_data';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__tokens_add extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_TOKENS_ADD;

  token_language!: string;
  user_language!: string;

  entity_id!: string;

  tokens_data!: DTOTokenCreateData[];

  /*
   * METHODS
   */

  constructor(entity_id: string = '') {
    super();

    this.entity_id = entity_id;

    this.tokens_data = [];
  }

  assert_standard_fields(): void {
    assert_type_enum(this.token_language, ENUM__language_type);
    assert_type_enum(this.user_language, ENUM__language_type);

    assert_string_object_id(this.entity_id);

    assert_array_not_empty(this.tokens_data);
  }
}
